import React from 'react'
import i18 from '../../i18'
import NotificationSystem from 'react-notification-system'
import api from '../../source/api'
import Loading from '../common/loading'
import BaseComponent from '../base'


class SavedPartners extends BaseComponent {

    constructor(props) {
        super(props)
        this._notificationSystem = null
        this.state = {
            axiosDone: false,
            company_id: props.company_id,
            deletePartner: false,
            partners: [],
        }
    }

    componentDidMount = () => {
        this._notificationSystem = this.refs.notificationSystem
        window.scrollTo(0, 0)
    }

    /**
     * @deprecated To be deprecated in React v17.
     * todo: Use componentDidMount instead.
     */
    componentWillMount = () => {
        this.getPartners()
    }

    _addNotification = (msg, type, time = 30) => {
        this.refs.notificationSystem.addNotification({
            message: msg,
            level: type,
            position: 'tc',
            autoDismiss: time
        })
    }

    getPartners = () => {
        api.get('bank/' + this.state.company_id + '/partners')
            .then((response) => {
                this.setState({
                    partners: response.data.partners,
                    axiosDone: true
                })
            })
            .catch((error) => {
                this.setState({
                    axiosDone: true
                })
            })
    }

    onRemovePartner = id => {
        if (window.confirm('Biztos törölni szeretné?')) {
            api.delete('bank/' + this.state.company_id + '/partner/' + id)
                .then((response) => {
                    this.setState({
                        partners: response.data.partners,
                        deletePartner: true
                    });
                    this._addNotification('Partner szabály törlése sikeres.', 'success', 10)
                })
                .catch((err) => {
                    this.closeModal()
                    this._addNotification('Partner szabály törlése sikertelen.', 'error', 30)
                })
        }
    }


    hidePartnersBox = () => {
        this.props.editSavedPartners(this.state.deletePartner)
    }


    getPartnersList = () => {
        let partnersList = []
        if (!Object.keys(this.state.partners).length) return
        const partners = [...this.state.partners]
        partners.map(item => partnersList.push(
            <tr key={item.id}>
                <td>{item.vsz_company_name}</td>
                <td>{item.bank_partner_unmodified_company_name}</td>
                <td>{item.updated_at}</td>
                <td>
                    <i onClick={(id) => this.onRemovePartner(item.id)} title={i18.CUSTOMER._deleteRule} className='fa fa-trash-o' aria-hidden='true'></i>
                </td>
            </tr>
        ))
        return partnersList
    }

    render() {
        if (!this.state.axiosDone && !this.state.partners.length) {
            return <div className='container text-center'><Loading/></div>
        }
        return (
            <section id='customer-rules'>
                <div className='header'>
                    <div className='container'>
                        <div className='row'>
                            <div className='col-12'>
                                <h1>
                                    <a onClick={() => this.hidePartnersBox()} className='choose-btn'>{i18.BUTTONS._back}</a> {i18.CUSTOMER._partnersDeleteTitle}
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='body'>
                    <div className='container'>
                        <div className='row'>
                            <div className='col-12'>
                                <table className='table table-striped table-aibook-no-border'>
                                    <thead>
                                    <tr>
                                        <th>{i18.BANK._bankCompanyName}</th>
                                        <th>{i18.BANK._vszCompanyName}</th>
                                        <th>Módosítva</th>
                                        <th>{i18.CUSTOMER._deleteRule}</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {this.getPartnersList()}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <NotificationSystem ref='notificationSystem'/>
            </section>
        )
    }
}

export default SavedPartners


// WEBPACK FOOTER //
// ./src/components/bank/savedpartners.js